import NearLocation from './NearLocation.container';

export default NearLocation;
